import React, { useEffect, useState } from 'react';
import { getMethodology } from '../api/api';

const Methodology = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getMethodology()
      .then((r) => setData(r.data))
      .catch((err) => setError(err.response?.data?.detail || 'Δεν ήταν δυνατή η φόρτωση της μεθοδολογίας.'));
  }, []);

  if (error) return <div className="error-message">{error}</div>;
  if (!data) return <div className="card">Φόρτωση AlgoStock Trading Framework…</div>;

  return (
    <div style={{maxWidth: '1080px', margin: '0 auto'}}>
      <div style={{marginBottom: '2rem'}}>
        <div style={{fontSize: '.78rem', color: '#75a9ff', fontWeight: 800, letterSpacing: '.12em'}}>ALGOSTOCK TRADING FRAMEWORK · {data.version}</div>
        <h1 style={{marginTop: '.5rem'}}>{data.title}</h1>
        <p style={{maxWidth: '780px', color: '#9da7b5', fontSize: '1.02rem'}}>{data.description}</p>
      </div>

      <div style={{display: 'grid', gap: '1rem'}}>
        {data.modules.map((module) => (
          <details key={module.id} className="card" open={module.id === '01'}>
            <summary style={{cursor: 'pointer', listStyle: 'none'}}>
              <div style={{display: 'flex', gap: '1rem', alignItems: 'center'}}>
                <div style={{
                  minWidth: '42px', height: '42px', borderRadius: '10px',
                  display: 'grid', placeItems: 'center',
                  background: 'rgba(65,128,255,.12)', border: '1px solid rgba(65,128,255,.28)',
                  fontWeight: 800, color: '#7fb0ff'
                }}>{module.id}</div>
                <div>
                  <h2 style={{fontSize: '1.25rem', margin: 0}}>{module.title}</h2>
                  <div style={{color: '#8f9aa9', marginTop: '.2rem'}}>{module.subtitle}</div>
                </div>
              </div>
            </summary>

            <div style={{paddingTop: '1.15rem', marginTop: '1.15rem', borderTop: '1px solid rgba(255,255,255,.08)'}}>
              <ul style={{display: 'grid', gap: '.65rem', paddingLeft: '1.25rem'}}>
                {module.lessons.map((lesson) => <li key={lesson}>{lesson}</li>)}
              </ul>
              <div style={{marginTop: '1rem', padding: '1rem', borderRadius: '10px', background: 'rgba(255,255,255,.025)'}}>
                <strong>Πρακτική εφαρμογή</strong>
                <div style={{color: '#a7b0bd', marginTop: '.35rem'}}>{module.practice}</div>
              </div>
            </div>
          </details>
        ))}
      </div>

      <div className="card" style={{marginTop: '1.25rem', color: '#929cab'}}>
        {data.disclaimer}
      </div>
    </div>
  );
};

export default Methodology;
